<template>
    <checkout-step step-num="5" :step="step" stepName="Confirmation" @continue="$emit('valid')">
        <div slot="active">
            <p>Are all your order details correct?</p>
        </div>
    </checkout-step>
</template>

<script>
import CheckoutStep from '../CheckoutStep';

export default {
  components: { CheckoutStep },
  name: 'checkout-confirmation',

  props: ['step', 'data'],
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout-steps/CheckoutStep5.vue